import { initActionMenuState } from './utils';

import {
    ACTION_MENUS_INIT,
    OPEN_ACTION_MENU,
    CLOSE_ACTION_MENU
} from './constants';

export const actionMenusInit = (forms) => {
    return dispatch => {
        const actionMenus = initActionMenuState(forms);
        dispatch({
            type: ACTION_MENUS_INIT,
            payload: actionMenus
        });
    };
};

export const openActionMenu = (urlFormId, el) => ({
    type: OPEN_ACTION_MENU,
    payload: { urlFormId, el }
});

export const closeActionMenu = (urlFormId) => ({
    type: CLOSE_ACTION_MENU,
    payload: urlFormId
});
